import { getFormValues } from 'redux-form';
import Bucketlists from '../../services/rest/Bucketlists';
import Utils from '../../services/Utils';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer,
    getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction
} = createRestSlices(Bucketlists);

const BUCKETLIST_FORM = 'bucketlistForm';

const initialBucket = () => {
    return {
        _id: 'new_' + Utils.randomString(6),
        may_steal_from: [],
        total_capacity: 'total_capacity',
        rules: {
            not_after: 'stop_at'
        }
    }
}

/** Merge redux-form bucket edits into Redux buckets (form lags behind until reinitialize). */
export const mergeBucketsWithFormValues = (reduxBuckets = [], formBuckets = []) => (
    (reduxBuckets || []).map((bucket, index) => {
        const formBucket = formBuckets?.[index];
        if (!formBucket)
            return bucket;
        return {
            ...bucket,
            ...formBucket,
            rules: {
                ...(bucket?.rules || {}),
                ...(formBucket.rules || {}),
            },
        };
    })
);

const reducer = (state, action) => {
    switch (action.type) {
        case ADD_BUCKET:
            return {
                ...state,
                bucketlist: {
                    ...state.bucketlist,
                    buckets: [
                        ...mergeBucketsWithFormValues(
                            state.bucketlist.buckets,
                            action.formBuckets
                        ),
                        initialBucket()
                    ]
                }
            };
        case CHANGE_BUCKET:
            return {
                ...state,
                bucketlist: {
                    ...state.bucketlist,
                    buckets: state.bucketlist.buckets.map((bucket, index) => {
                        // Prefer index: form _id may differ from Redux while the user edits it.
                        if (typeof action.bucketIndex === 'number')
                            return index !== action.bucketIndex ? bucket : action.bucket;
                        return bucket._id !== action.bucket?._id ? bucket : action.bucket;
                    })
                }
            };
        case REORDER_BUCKETS:
            return {
                ...state,
                bucketlist: {
                    ...state.bucketlist,
                    buckets: action.buckets,
                }
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer,
        reducer
    ]);
}

/* Export CRUD actions */
export const startCreateBucketlist = startCreateAction;
export const createBucketlist      = createAction;
export const loadBucketlist        = getAction;
export const loadBucketlists       = listAction;
export const updateBucketlist      = updateAction;
export const deleteBucketlist      = deleteAction;
export const duplicateBucketlist   = duplicateAction;

export function setBucketlistAsDefault(bucketlist) {
    return (dispatch) => dispatch(updateAction({ ...bucketlist, is_default: true }))
        .then(() => dispatch(loadBucketlists()));
}

export function unsetBucketlistAsDefault(bucketlist) {
    return (dispatch) => dispatch(updateAction({ ...bucketlist, is_default: false }))
        .then(() => dispatch(loadBucketlists()));
}

const ADD_BUCKET = 'kronos/bucketlists/ADD_BUCKET';
export const addBucket = () => (dispatch, getState) => {
    // Sync in-progress form edits into Redux before appending, otherwise
    // enableReinitialize would wipe dirty contingent fields (e.g. _id).
    const formValues = getFormValues(BUCKETLIST_FORM)(getState()) || {};
    dispatch({ type: ADD_BUCKET, formBuckets: formValues.buckets || [] });
};

const CHANGE_BUCKET = 'kronos/bucketlists/CHANGE_BUCKET';
export function changeBucket(bucket, bucketIndex) {
    return (dispatch) => {
        return dispatch({ type: CHANGE_BUCKET, bucket, bucketIndex });
    };
}

const REORDER_BUCKETS = 'kronos/bucketlists/REORDER_BUCKETS';
/** Local-only bucket order (drag). Persist via the impact wizard / save. */
export function reorderBuckets(buckets) {
    return { type: REORDER_BUCKETS, buckets };
}
